import { Link } from 'react-router-dom';
import { trackPhoneCall } from '@/lib/gtag';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <h3 className="text-2xl font-bold mb-4">
              <span className="text-white">PLUMBERS</span>{' '}
              <span className="text-primary">NOW</span>
            </h3>
            <p className="text-gray-300 mb-6 max-w-md">
              Especialistas em serviços de canalização em Lisboa. Reparação urgente, desentupimentos, 
              instalação e manutenção. Técnicos locais, atendimento 24h e orçamentos gratuitos.
            </p>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-primary" />
                <a href="tel:+351960488777" className="hover:text-primary transition-colors" onClick={() => trackPhoneCall('+351960488777')}>
                  960 488 777
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-primary" />
                <a href="mailto:plumbersnow.pt@gmail.com" className="hover:text-primary transition-colors">
                  plumbersnow.pt@gmail.com
                </a>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-primary mt-1" />
                <div>
                  <div>Rua Capitao Humberto de Ataide 1</div>
                  <div>1170-072 Lisboa, Portugal</div>
                </div>
              </div>
            </div>
          </div>


          {/* Areas */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Zonas Atendidas</h4>
            <ul className="space-y-2 text-gray-300">
              <li>Lisboa</li>
              <li>Amadora</li>
              <li>Oeiras</li>
              <li>Almada</li>
              <li>Seixal</li>
              <li>Setúbal</li>
              <li className="text-primary">+ Muitas outras zonas</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="text-gray-400 text-sm">
              © 2025 PLUMBERS NOW. Todos os direitos reservados.
            </div>
            <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 text-sm">
              <Link to="/sobre-nos" className="text-gray-300 hover:text-white transition-colors p-2">
                Sobre Nós
              </Link>
              <Link to="/contato" className="text-gray-300 hover:text-white transition-colors p-2">
                Contato
              </Link>
              <Link to="/politica-de-privacidade" className="text-gray-300 hover:text-white transition-colors p-2">
                Política de Privacidade
              </Link>
              <a 
                href="https://foturemarketing.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-white transition-colors p-2"
              >
                desenvolvido por foturemarketing.com
              </a>
            </div>
          </div>
          <div className="text-center mt-4 text-xs text-gray-500">
            Cumprimos RGPD. Dados usados apenas para resposta ao seu pedido.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
